export const mapFiltersToUrlParams = (filters) => {
    const paramGroups = {};
    filters.forEach((section) => {
        if (section.param) {
            const checkedValues = section.items
                .filter((item) => item.checked)
                .flatMap((item) => {
                return Array.isArray(item.value) ? item.value : [item.value];
            });
            if (checkedValues.length > 0) {
                paramGroups[section.param] = [...(paramGroups[section.param] || []), ...checkedValues];
            }
        }
    });
    Object.keys(paramGroups).forEach((param) => {
        paramGroups[param] = Array.from(new Set(paramGroups[param]));
    });
    return paramGroups;
};
